import { PageId } from 'constants/pages'

export const enum PageIdWoofzWa1 {
  SUBSCRIPTIONS_WA1 = PageId.SUBSCRIPTIONS_WA1,
  CANCEL_OFFER_WA1 = PageId.CANCEL_OFFER_WA1,
  DOWNLOAD_WA1 = PageId.DOWNLOAD_WA1,
}
